/** Default appointments calendar route. */
export function appointmentsCalendarPath(_date?: string | Date): string {
  return '/appointments';
}

/** True when the todos monthly view is showing the appointments calendar. */
export function isAppointmentsCalendarLocation(pathname: string, search: string): boolean {
  if (pathname !== '/todos_monthly_view') return false;
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return params.get('appointments') === '1';
}

/** Sidebar highlight for Appointments (calendar at /appointments; legacy todos URL still supported). */
export function isAppointmentsSidebarActive(pathname: string, search: string): boolean {
  return (
    pathname === '/appointments' ||
    pathname.startsWith('/appointments/') ||
    pathname === '/appointments_calendar_view' ||
    isAppointmentsCalendarLocation(pathname, search)
  );
}

/** Sidebar highlight for Todos — exclude the shared appointments calendar route. */
export function isTodosSidebarActive(pathname: string, search: string, itemPath = '/todos_monthly_view'): boolean {
  if (isAppointmentsCalendarLocation(pathname, search)) return false;
  return pathname === itemPath || (itemPath !== '/' && pathname.startsWith(`${itemPath}/`));
}
